import { GeoZoneDto } from '@trucktrax/trucktrax-ts-common';
import { SET_CURRENT_GEOZONE } from '../../constants/actionConstants';

export const setCurrentGeozone = (value: GeoZoneDto | undefined) => ({
  type: SET_CURRENT_GEOZONE,
  payload: value,
});
